// extracted by mini-css-extract-plugin
export default {"desktopMinWidth":"1024","mobileMaxWidth":"700","mobileMaxHeightLandscape":"480","zIndexModal":"3000","root":"ModalIcon_root__R3yoa","error":"ModalIcon_error__wOMR0"};